import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  // StrictMode 会导致开发环境下 useEffect 执行两次，
  // 为了方便观察 WebSocket 连接，我们可以暂时保留，或者去掉
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
